import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_ChooseForm = _resolveComponent("ChooseForm")!
  const _component_SelectedProducts = _resolveComponent("SelectedProducts")!
  const _component_CreateTransferFrom = _resolveComponent("CreateTransferFrom")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: "edit_transfer",
        items: _ctx.breadcrumbItems,
        showHome: false
      }, null, 8, ["items"]),
      _createVNode(_component_ChooseForm, {
        warehouses: _ctx.warehouses,
        fromWarehouseId: _ctx.form.from_warehouse_id,
        "onUpdate:fromWarehouseId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.from_warehouse_id) = $event)),
        toWarehouseId: _ctx.form.to_warehouse_id,
        "onUpdate:toWarehouseId": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.to_warehouse_id) = $event)),
        referenceNo: _ctx.form.ref,
        date: _ctx.form.date,
        fromWarehouseLocked: _ctx.fromWarehouseLockedToProfile,
        isLoading: _ctx.isLoadingData,
        onSearchProduct: _ctx.handleProductSearch,
        searchResults: _ctx.searchResults,
        showResults: _ctx.showResults,
        onAddProduct: _ctx.addProduct
      }, null, 8, ["warehouses", "fromWarehouseId", "toWarehouseId", "referenceNo", "date", "fromWarehouseLocked", "isLoading", "onSearchProduct", "searchResults", "showResults", "onAddProduct"]),
      _createVNode(_component_SelectedProducts, {
        items: _ctx.items,
        onRemoveItem: _ctx.removeItem,
        onUpdateQty: _ctx.updateQty
      }, null, 8, ["items", "onRemoveItem", "onUpdateQty"]),
      _createVNode(_component_CreateTransferFrom, {
        form: _ctx.form,
        items: _ctx.items,
        "total-qty": _ctx.totalQty,
        "sub-total": _ctx.subTotal,
        "grand-total": _ctx.grandTotal,
        onSubmit: _ctx.submitTransfer,
        "onUpdate:formKey": _ctx.updateForm
      }, null, 8, ["form", "items", "total-qty", "sub-total", "grand-total", "onSubmit", "onUpdate:formKey"]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}